module.exports = __webpack_public_path__ + "static/media/MK 23.54e76cd4.mp3";